import { DefaultButton, TextField } from '@fluentui/react';
import { useContext } from 'react';
import { useState } from 'react';
import MaskedIpInput from '../createSensorModal/components/maskedIpInput';
import { ModalContext } from '../modalCreator';
import { UpdateSensorModalTitle, FieldWrapper, ButtonWrapper, StyledPort } from './updateSensorModal.styles';
import { MAC_ADDRESS_REGEXP } from '../../../constants/regexp';

/**
 * Модальное окно для обновления сенсора
 * @param {object} sensorToUpdate сенсор, который нужно обновить
 * @param {function} closeUpdateSensorModal функция для закртия модального окна
 */
const UpdateSensorModal = ({ sensorToUpdate, closeUpdateSensorModal }) => {
    const { updateSensorThunkTrans } = useContext(ModalContext);
    const [ip, setIp] = useState(sensorToUpdate.ip);
    const [ipError, setIpError] = useState(false);
    const [port, setPort] = useState(sensorToUpdate.port);
    const [portError, setPortError] = useState(false);
    const [login, setLogin] = useState(sensorToUpdate.username);
    const [password, setPassword] = useState(sensorToUpdate.password);
    const [passwordError, setPasswordError] = useState(false);
    const [macAddress, setMacAddress] = useState(sensorToUpdate.macaddress);
    const [macAddressError, setMacAddressError] = useState(false);

    const ipHandler = (e) => {
        setIpError(false);
        setIp(e.target.value);
    };

    const portHandler = (_, newValue) => {
        setPortError(false);
        setPort(newValue);
    };

    const loginHandler = (_, newValue) => setLogin(newValue);

    const passwordHandler = (_, newValue) => {
        setPasswordError(false);
        setPassword(newValue);
    };

    const macAddressHandler = (_, newValue) => {
        setMacAddressError(false);
        setMacAddress(newValue);
    };

    const updateHandler = () => {
        if (ip && port && password && (macAddress ? MAC_ADDRESS_REGEXP.test(macAddress) : true)) {
            updateSensorThunkTrans(
                ip,
                port,
                sensorToUpdate.id,
                password,
                login,
                sensorToUpdate.sensor_type,
                macAddress,
            );
            closeUpdateSensorModal();
        } else {
            if (!ip) setIpError(true);
            if (!port) setPortError(true);
            if (!password) setPasswordError(true);
            if (macAddress && !MAC_ADDRESS_REGEXP.test(macAddress)) setMacAddressError(true);
        }
    };

    return (
        <>
            <UpdateSensorModalTitle>Update sensor</UpdateSensorModalTitle>
            <FieldWrapper>
                <MaskedIpInput inputError={ipError} inputValue={ip} setInputValue={ipHandler} label="Ip" />
                <StyledPort
                    errorMessage={portError ? 'Required' : null}
                    onChange={portHandler}
                    value={port}
                    label="Port"
                />
            </FieldWrapper>

            <TextField value={login} onChange={loginHandler} label="Login (optional)" title="Login" />
            <TextField
                value={password}
                errorMessage={passwordError ? 'This field is required' : null}
                onChange={passwordHandler}
                label="Password"
                type="password"
                title="Password"
            />
            <TextField
                value={macAddress}
                placeholder={'__:__:__:__:__:__'}
                errorMessage={macAddressError ? 'Wrong mac address' : null}
                onChange={macAddressHandler}
                label={'MAC-address (optional)'}
            />
            <ButtonWrapper>
                <DefaultButton onClick={updateHandler}>Update</DefaultButton>
            </ButtonWrapper>
        </>
    );
};

export default UpdateSensorModal;
